import * as z from "zod";
import { SealedScreenControlSchema } from "./screen-control.js";

const id = z.string().uuid();
const relative = z
  .string()
  .max(4096)
  .refine((value) => value.startsWith("/") && !value.startsWith("//") && !/[\r\n\\]/.test(value));
export const NodeTunnelFrameSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("http"), id, routeId: id, path: relative }),
  z.object({
    kind: z.literal("http-result"),
    id,
    status: z.number().int().min(100).max(599),
    contentType: z.string().max(200),
    body: z.string().max(5_600_000),
    screenDirect: z.literal(1).optional(),
  }),
  z.object({ kind: z.literal("open"), id, routeId: id, path: relative }),
  z.object({ kind: z.literal("opened"), id }),
  z.object({ kind: z.literal("data"), id, body: z.string().max(350_000), binary: z.boolean() }),
  z.object({ kind: z.literal("close"), id }),
  /** Gateway to node only: a sealed grant or revocation for one armed route's input. */
  z.object({ kind: z.literal("control"), id, ...SealedScreenControlSchema.shape }),
]);
export type NodeTunnelFrame = z.infer<typeof NodeTunnelFrameSchema>;
